module.exports = __webpack_public_path__ + "img/boxed-20.d5603779.jpg";